export enum ECorrectionsTab {
  PAYMENTS = 'payments',
  LICENSES = 'licenses',
  TARIFFS = 'tariffs',
  SMS_CHANNEL = 'sms_channel',
  MIGRATION = 'migration',
}

export enum EMigrationTab {
  SUBJECTS = 'subjects',
  PRISM = 'prism',
}

export type TTariffTransfer = {
  oldTariffCatalogId: number;
  oldLicenseDetailId: number;
  newTariffCatalogId: number;
  newLicenseDetailId: number;
  resetCoefficients: boolean;
  activeFrom: Date;
};

export const TABS = Object.values(ECorrectionsTab);
